import { render, staticRenderFns } from "./BasicFileInput.vue?vue&type=template&id=2cacf4b1"
import script from "./BasicFileInput.vue?vue&type=script&lang=js"
export * from "./BasicFileInput.vue?vue&type=script&lang=js"
import style0 from "./BasicFileInput.vue?vue&type=style&index=0&id=2cacf4b1&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports